import { getEnvironmentConfig, getEnvVariableDefault } from '../configHelper.js';
const definition = {
    base: {
        clickhouseApiUrl: 'https://rt-api.bf-tracking-production.aws.bfops.io/clickhouse/query',
        clickhouseApiKey: getEnvVariableDefault('TRACKING_REALTIME_API_KEY', ''),
    },
    local_e2e: {
        clickhouseApiUrl: '',
        clickhouseApiKey: '',
    },
    test: {
        clickhouseApiUrl: '',
        clickhouseApiKey: '',
    },
};
export const performanceDataConfig = () => getEnvironmentConfig(definition);
//# sourceMappingURL=performance-data.config.js.map